import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Checkbox from "./form/Checkbox";

const validationSchema = Yup.object({});

const styles = {
  checkbox: {
    px: 1,
    display: "flex",
    justifyContent: "space-between",
    height: 56,
    borderRadius: "4px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    "& label": {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-between",
      ml: 1,
      height: 56,
    },
    "& .MuiTypography-root": {
      fontSize: "16px !important",
    },
  },
};

export default function AdvancedOptionsDialog({
  onClose,
  onSave,
  initialValues = {},
  showMultipleValues = false,
}) {
  const handleSubmit = values => {
    onSave(values);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ position: "relative", textAlign: "center" }}>
        <Typography fontSize={22} fontWeight={500} color="textPrimary" align="center">
          Advanced Options
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Formik
        initialValues={{
          restrictToAvailableOptions: initialValues.restrictToAvailableOptions || false,
          autoAddCustomValues: initialValues.autoAddCustomValues || false,
          enableBarcodeScanner: initialValues.enableBarcodeScanner || false,
          multipleValues: initialValues.multipleValues || false,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <DialogContent>
              <Box>
                <Grid container spacing={1}>
                  <Grid size={12}>
                    <Box sx={styles.checkbox}>
                      <Checkbox
                        name="restrictToAvailableOptions"
                        label="Only Allow Dropdown Values"
                      />
                    </Box>
                  </Grid>
                  <Grid size={12}>
                    <Box sx={styles.checkbox}>
                      <Checkbox name="autoAddCustomValues" label="Auto Add New Values" />
                    </Box>
                  </Grid>
                  <Grid size={12}>
                    <Box sx={styles.checkbox}>
                      <Checkbox name="enableBarcodeScanner" label="Enable Barcode Scanner" />
                    </Box>
                  </Grid>
                  {showMultipleValues && (
                    <Grid size={12}>
                      <Box sx={styles.checkbox}>
                        <Checkbox name="multipleValues" label="Allow Multiple Values" />
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={onClose} variant="outlined">
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
